<style>
    .foo {
        background: #e7e7e7;
    }

    th .status-column-style {
        max-width: 60px;
    }
</style>
<template>
    <div>
        <div class="row">
            <br/>
            <div class="col-md-4 col-md-offset-6 pull-right">
                <div class="form-group">
                    <label class="control-label" for="focusedInput" style="margin-left:5px">MAR Date</label>
                    <simpledatepicker v-model="selectedDate"></simpledatepicker>
                </div>
            </div>
        </div>
        <transition name="fade" :duration="1000">
            <div v-show="isLoading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <div v-if="!isLoading && patientRounds.length > 0" class="table-responsive">
            <div class="progress" style="height: 1px;">
                <div class="progress-bar" role="progressbar" v-bind:aria-valuenow="timeleft" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: timeleft + '%'}"></div>
            </div>
            <table class="table table-striped table-hover" style="width:100%">
                <thead>
                    <tr>
                        
                        <th width="150">MAR Date</th>
                        <th width="Auto" class="text-center" v-for="group in groups">{{group.medRoundGroupName}}</th>
                        <!--th width="Auto" class="text-center">Warfarin</th>
                        <th width="Auto" class="text-center">Non-Scheduled</th>
                        <th />-->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) of patientRounds" v-bind:style="{'background' : index == 0 ? '#8bc3f37a' : ''}">
                        
                        <td>{{ formatDate(item.DispensationDate)}} </td>
                        <td class="text-center" v-for="group of item.groups">
                            <a data-toggle="tooltip" data-placement="top" :title="statusText(group.medRoundGroupStatus)">
                                  <DispensationStatusIcon :group="group" />
                            </a>
                        </td>
                        <!--<td class="text-center">
                             <DispensationStatusIcon :status="item.warfarinGroupStatus" />
                        </td>
                        <td class="text-center">
                            <a data-toggle="tooltip" data-placement="top" title="Insulin" v-if="item.insulin.length > 0">
                                <span class="fa-stack fa-1x">
                                    <i class="fa fa-circle-o fa-stack-2x"></i>
                                    <strong class="fa-stack-1x">I</strong>
                                </span>
                            </a>
                            <a data-toggle="tooltip" data-placement="top" title="PRN" v-if="item.prn.length > 0">
                                <span class="fa-stack fa-1x">
                                    <i class="fa fa-circle-o fa-stack-2x"></i>
                                    <strong class="fa-stack-1x">P</strong>
                                </span>
                            </a>
                            <a data-toggle="tooltip" data-placement="top" title="No Non-Scheduled Dispensations" v-if="item.prn.length == 0 && item.insulin.length == 0">
                                <i class="fa fa-2x fa-circle-o text-muted">
                                </i>
                            </a>
                        </td>-->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="alert alert-warning" v-if="!isLoading && patientRounds.length == 0">
            <h4>No records! Really</h4>
        </div>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import simpledatepicker from "../../corecontrols/simpledatepicker/simpledatepicker.scp.html";
    import PatientRoundViewModel from "./PatientRoundViewModel"
    import CarehomeSelector from "../../appcontrols/carehomeselector/carehomeselector.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto, DispensationRoundGroup } from "./../../../dto/Dtos";
    import { PatientDto } from "./../../../dto/PatientDto";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import moment from "moment";
    import DispensationStatusIcon from "../../appcontrols/dispensationStatusIcon/dispensationStatusIcons.scp.html"

    export default {
        props: {
            patientid: {
                type: String,
                required: true
            }
        },
        watch: {
            selectedDate() {
                console.log("Selected Date changed", this.selectedDate)
                this.LoadMarHistory();
            }
        },
        mounted: function () {
            console.log("Patient MAR History mounted with ", this.patientid)

        },
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;
            return {
                carehome: {},
                isLoading: true,
                patient: null,
                groups: [],
                patientRounds: [],
                selectedDate: new Date()
            }
        },
        methods: {
            formatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },
            statusText: function (status) {
                if (status == 0) {
                    return 'No Meds'
                }
                else if (status == 15) {
                    return 'All Meds Taken'
                }
                else if (status == 25) {
                    return 'Skipped'
                }
                else if (status == 35) {
                    return 'Pending'
                }
                return 'Missed';
            },
            LoadMarHistory() {

                var dal = new Dal();
                var date = this.selectedDate;
                this.isLoading = true;
                this.groups = []
                this.patientRounds = []


                console.log("Setting Date as " + date);

                var that = this;
                dal.GetPatient(this.patientid).then(d => {
                    this.patient = d;
                    that.LoadPatientMarHistory();
                })
            },
            LoadPatientMarHistory() {
                var dal = new Dal();
                var startDate = this.selectedDate;
                var promises = [];
                var that = this;
                //console.log("Patients", this.patients);

                for (var dateIndex = 0; dateIndex <= 10; dateIndex++) {
                    var date = moment(startDate).add(-1 * dateIndex, 'days');
                    console.log("Date Sequence ", dateIndex, date, startDate)
                    promises.push(this.loadPatientRounds(this.patient.pharmacyPatientId, date));
                }

                Promise.all(promises).then(data => {
                    this.groups = [];
                    this.patientRounds = [];
                    //console.log("Data=================================",data);

                    for (var patientData of data) {

                        var patientRound = {}
                        patientRound.patient = this.patient;
                        patientRound.DispensationDate = patientData.DispensationDate;
                        patientRound.groups = {}
                        for (var group of patientData.mar.roundGroups) {
                            if (that.groups.filter(g => g.medRoundGroupName == group.medRoundGroupName).length == 0) {
                                that.groups.push(group);
                            }
                            //patientRound.groups[group.medRoundGroupName] = group.medRoundGroupStatus;
                            patientRound.groups[group.medRoundGroupName] = group;
                        }

                        patientRound.warfarinGroupStatus = patientData.mar.warfarinGroupStatus ? patientData.mar.warfarinGroupStatus : 0;
                        patientRound.insulin = patientData.mar.insulin ? patientData.mar.insulin : [];
                        patientRound.prn = patientData.mar.prn ? patientData.mar.prn : [];
                        this.patientRounds.push(patientRound);
                        //console.log(patientRound);
                    }
                    console.log("--------------------------------------", this.patientRounds)
                    this.isLoading = false;
                })
            },
            loadPatientRounds(id, date) {
                var dal = new Dal();
                var promise = dal.GetDispensationMar(date, id).then(data => {
                    return { patientid: id, DispensationDate:date, mar: data };
                });
                return promise;
            }
        },
        components: {
            datatable,
            Formatter,
            simpledatepicker,
            CarehomeSelector,
            DispensationStatusIcon
        }
    }
</script>



// WEBPACK FOOTER //
// Patient-Mar-History.scp.html?3fd2d69c